import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { ACLService } from '@delon/acl';
import { _HttpClient } from '@delon/theme';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { catchError, finalize, of } from 'rxjs';
import { FormService } from 'src/app/core/util/form.service';
import { DataBaseService } from 'src/app/shared-feature/services/_base/data-base.service';
import { ListBaseService } from 'src/app/shared-feature/services/_base/list-base.service';

import { SSTReturnDeclarationInfoModalComponent } from '../../modal/sst-return-declaration-info-modal/sst-return-declaration-info-modal.component';

@Component({
  selector: 'app-data-edit-actions',
  templateUrl: './data-edit-actions.component.html',
  styleUrls: ['./data-edit-actions.component.less'],
  standalone: false
})
export class DataEditActionsComponent implements OnInit {
  @Input() aclKey: string | undefined;
  @Input() data: any;
  @Input() allowEdit: boolean = true;
  @Input() disableEdit: boolean = false;
  @Input() reportType: string | undefined;
  @Input() sstReturnStatus: boolean = false;
  @Input() onAction!: (action: string) => Promise<any>;
  @ViewChild('whatsappF') whatsappF!: NgForm;
  @ViewChild('emailF') emailF!: NgForm;
  @ViewChild('sstReturn') sstReturn!: SSTReturnDeclarationInfoModalComponent;
  saving = false;
  remark = 'Format: <Country Code> + <Telephone Number>';
  shareOption = '';
  customerId: number | null = null;
  customerName = '';
  supplierId: number | null = null;
  supplierName = '';
  phoneNumber = '';
  emailList = [];
  loading = false;
  modalVisible: any = {
    email: false,
    whatsapp: false,
    sstReturn: {
      submit: false,
      unlock: false
    }
  };

  constructor(
    private modal: NzModalService,
    private msg: NzMessageService,
    private acl: ACLService,
    private router: Router,
    private route: ActivatedRoute,
    private fs: FormService,
    private http: _HttpClient,
    private listSrv: ListBaseService,
    private cdr: ChangeDetectorRef,
    public srv: DataBaseService,
    private reuseTabSrv: ReuseTabService
  ) {}

  get id() {
    return this.route.snapshot.params['id'];
  }

  get canCreate() {
    if (this.aclKey) {
      return this.acl.can({ ability: [`${this.aclKey}.create`] });
    }

    return true;
  }

  get canEdit() {
    if (this.aclKey) {
      return this.acl.can({ ability: [`${this.aclKey}.update`] });
    }

    return true;
  }

  get canDelete() {
    if (this.aclKey) {
      return this.acl.can({ ability: [`${this.aclKey}.delete`] });
    }

    return true;
  }

  get einvEnabled() {
    return this.acl.can({ ability: ['einv.enabled'] });
  }

  get einvFullValidationEnabled() {
    return this.acl.can('einv.full-validation');
  }

  ngOnInit(): void {
    if (this.id === '0') {
      if (this.listSrv.cloneData) {
        this.editData(this.listSrv.cloneData);
        this.listSrv.cloneData = null;
      } else {
        this.loadNew();
      }
    } else {
      this.reload();
    }

    // Listen for custom events to show SST modals (triggered from detail component)
    if (this.reportType === 'sst-return') {
      // Listen for submit modal event
      window.addEventListener('showSubmitModal', () => {
        this.modalVisible.sstReturn.submit = true;
        this.cdr.detectChanges();
      });

      // Listen for unlock modal event
      window.addEventListener('showUnlockModal', () => {
        this.modalVisible.sstReturn.unlock = true;
        this.cdr.detectChanges();
      });
    }
  }

  toggleMode(mode: 'view' | 'edit') {
    this.srv.observeChanges = false;
    if (mode === 'edit') this.fs.enable(this.srv.form);
    else this.fs.disable(this.srv.form);

    this.fs.resetErrors(this.srv.form);
    this.srv.modified = false;
    this.srv.editing = mode === 'edit';
    this.srv.loading = this.saving = this.srv.deleting = false;
    this.srv.observeChanges = mode === 'edit';
  }

  share(option: string) {
    this.customerId = null;
    this.customerName = '';

    this.supplierId = null;
    this.supplierName = '';

    this.shareOption = '';
    this.phoneNumber = '';
    this.emailList = [];
    this.shareOption = option;

    if (this.data) {
      if (this.aclKey === 'supplier') {
        this.supplierId = this.data.supplierId;
        this.supplierName = this.data.supplierName;
        this.phoneNumber = this.data.phoneNumber;
        this.emailList = this.data.emailList;
      } else {
        this.customerId = this.data.customerId;
        this.customerName = this.data.customerName;
        this.emailList = this.data.emailList;
      }
    }

    if (this.shareOption === 'EMAIL') {
      this.modalVisible.email = true;
    } else if (this.shareOption === 'WHATSAPP') {
      this.modalVisible.whatsapp = true;
    } else {
      this.shareVia();
    }
  }

  shareVia() {
    if (
      this.shareOption === 'WHATSAPP' &&
      !this.fs.validate(this.whatsappF).isValid
    )
      return;
    if (this.shareOption === 'EMAIL' && !this.fs.validate(this.emailF).isValid)
      return;

    let data = {};
    let url = '';
    if (this.aclKey === 'supplier') {
      url = 'api/Suppliers/SendSupplierAdvisor';
      data = {
        supplierId: this.id,
        supplierName: this.supplierName,
        shareOption: this.shareOption,
        phoneNumber: this.phoneNumber,
        einvoiceEmailList: this.emailList
      };
    } else {
      url = 'api/Customers/SendCustomerAdvisor';
      data = {
        customerId: this.id,
        customerName: this.customerName,
        shareOption: this.shareOption,
        phoneNumber: this.phoneNumber,
        einvoiceEmailList: this.emailList
      };
    }

    this.srv.loading = true;
    this.http
      .post(url, data)
      .pipe(
        catchError(err => {
          return of(null);
        }),
        finalize(() => {
          this.srv.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: async (res: any) => {
          if (res) {
            if (this.shareOption !== 'LINK') {
              window.open(res, '_blank');
            } else if (this.shareOption === 'LINK') {
              // For LINK sharing, get clipboard permission BEFORE the HTTP request
              let clipboardPromise: Promise<ClipboardItem[]> | null = null;

              if (this.shareOption === 'LINK') {
                // Create clipboard promise immediately while we have user gesture
                clipboardPromise = navigator.clipboard?.read?.() || null;
              }

              try {
                const textToCopy =
                  typeof res !== 'string' ? JSON.stringify(res) : res;

                const success = await this.copyToClipboard(textToCopy);

                if (!success) {
                  this.showManualCopyDialog(textToCopy);
                }
              } catch (err) {
                console.error('Failed to copy:', err);
                this.showManualCopyDialog(
                  typeof res !== 'string' ? JSON.stringify(res) : res
                );
              }
            }
          }
          this.modalVisible.email = false;
          this.modalVisible.whatsapp = false;
          this.cdr.detectChanges();
          this.cdr.markForCheck();
        },
        error: err => {
          console.log('Error:', err);
        }
      });
  }

  private fallbackCopy(text: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // iOS requires special styling
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    textArea.style.top = '-9999px';
    textArea.style.width = '1px';
    textArea.style.height = '1px';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';

    // iOS requires readonly to be false
    textArea.readOnly = false;
    textArea.contentEditable = 'true';

    document.body.appendChild(textArea);

    // iOS Safari requires special focus and selection handling
    textArea.focus();
    textArea.setSelectionRange(0, text.length);

    setTimeout(() => {
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.msg.success('Message Copied!!!');
        } else {
          throw new Error('execCommand returned false');
        }
      } catch (err) {
        console.error('Fallback copy failed:', err);
        this.msg.error('Failed to copy message. Please copy manually.');
      }

      document.body.removeChild(textArea);
    }, 10);
  }

  private showManualCopyDialog(text: string): void {
    // Use Angular modal to show text for manual copying
    this.modal.create({
      nzTitle: 'Copy Text Manually',
      nzContent: `
        <div style="margin-bottom: 10px;">Please select and copy the text below:</div>
        <textarea readonly style="width: 100%; height: 150px; font-family: monospace; font-size: 12px; border: 1px solid #ccc; padding: 8px;" 
                  onclick="this.select()" onfocus="this.select()">${text}</textarea>
        <div style="margin-top: 10px; font-size: 12px; color: #666;">
          Tap the text area above, then select all and copy (Ctrl+C or Cmd+C)
        </div>
      `,
      nzFooter: [
        {
          label: 'Close',
          type: 'primary',
          onClick: () => true
        }
      ],
      nzWidth: '90%',
      nzStyle: { maxWidth: '500px' }
    });
  }

  private async copyToClipboard(text: string): Promise<boolean> {
    // 1. Prioritize modern Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        this.msg.success('Message Copied!');
        return true;
      } catch (err) {
        console.warn('Modern clipboard API failed:', err);
        // Fall through to fallback methods
      }
    }

    // 2. Fallback for iOS Safari and other browsers
    try {
      this.fallbackCopy(text);
      return true;
    } catch (err) {
      console.error('All clipboard methods failed:', err);
      return false;
    }
  }

  gotoNew() {
    const curUrl = this.reuseTabSrv.curUrl;
    if (curUrl.endsWith('/0')) {
      this.loadNew();
    } else {
      this.router.navigate(['../0'], { relativeTo: this.route }).then(() => {
        this.reuseTabSrv.close(curUrl);
      });
    }
  }

  private loadNew() {
    this.srv.loading = true;
    this.srv
      .new()
      .pipe(
        finalize(() => {
          this.srv.loading = false;
        })
      )
      .subscribe({
        next: res => {
          this.editData(res);
          this.srv.focus();
        }
      });
  }

  private editData(data: any) {
    this.srv.observeChanges = false;
    this.srv.setData(data);
    this.toggleMode('edit');
  }

  save() {
    this.srv.observeChanges = false;
    if (!this.srv.validate()) {
      this.srv.observeChanges = true;
      return;
    }
    const body = { ...this.srv._data };
    Object.assign(body, this.srv.form.value);
    this.srv.loading = this.saving = true;
    if (this.id === '0') {
      this.srv.create(body).subscribe({
        next: (res: any) => {
          this.listSrv.addRow(res);
          const newId = res?.id ?? res?.Id;
          const curUrl = this.reuseTabSrv.curUrl;
          this.srv
            .persistCapturedMasterAttachments(newId)
            .pipe(
              catchError(() => {
                this.msg.error(
                  'Saved, but attachments could not be uploaded.'
                );
                return of(null);
              }),
              finalize(() => {
                this.router
                  .navigate([`../${newId}`], {
                    relativeTo: this.route
                  })
                  .then(() => this.reuseTabSrv.close(curUrl));
                this.srv.editing = false;
                this.srv.observeChanges = false;
                this.srv.setData(res);
                this.srv.loading = this.saving = false;
                this.fs.disable(this.srv.form);
                this.srv.modified = false;
                this.updateTitle();
              })
            )
            .subscribe();
        },
        error: () => {
          this.srv.loading = this.saving = false;
        }
      });
    } else {
      if (this.canEdit) {
        this.srv.update(body).subscribe({
          next: res => {
            this.listSrv.updateRow(res);
            this.srv.observeChanges = false;
            this.srv.editing = false;
            this.srv.loading = this.saving = false;
            this.srv.setData(res);
            this.fs.disable(this.srv.form);
            this.srv.modified = false;

            this.updateTitle();
          },
          error: () => {
            this.srv.loading = this.saving = false;
          }
        });
      }
      this.srv.loading = this.saving = false;
    }
  }

  saveAndClose() {
    if (!this.srv.validate()) {
      return;
    }
    this.saving = true;
    this.srv.loading = true;
    const body = { ...this.srv._data };
    Object.assign(body, this.srv.form.value);
    if (this.id === '0') {
      this.srv.create(body).subscribe({
        next: res => {
          this.listSrv.addRow(res);
          const newId = res?.id ?? res?.Id;
          this.srv
            .persistCapturedMasterAttachments(newId)
            .pipe(
              catchError(() => {
                this.msg.error(
                  'Saved, but attachments could not be uploaded.'
                );
                return of(null);
              }),
              finalize(() => {
                this.saving = false;
                this.srv.loading = false;
                this.srv.modified = false;
                this.close();
              })
            )
            .subscribe();
        },
        error: () => {
          this.saving = false;
          this.srv.loading = false;
        }
      });
    } else {
      this.srv.update(body).subscribe({
        next: res => {
          this.listSrv.updateRow(res);
          this.saving = false;
          this.srv.loading = false;
          this.srv.modified = false;
          this.close();
        },
        error: () => {
          this.saving = false;
          this.srv.loading = false;
        }
      });
    }
  }

  saveAndNew() {
    if (!this.srv.validate()) {
      return;
    }
    const body = { ...this.srv._data };
    Object.assign(body, this.srv.form.value);

    this.saving = true;
    this.srv.loading = true;
    if (this.id === '0') {
      this.srv.create(body).subscribe({
        next: res => {
          this.listSrv.addRow(res);
          const newId = res?.id ?? res?.Id;
          this.srv
            .persistCapturedMasterAttachments(newId)
            .pipe(
              catchError(() => {
                this.msg.error(
                  'Saved, but attachments could not be uploaded.'
                );
                return of(null);
              }),
              finalize(() => {
                this.srv.loading = this.saving = false;
                this.srv.modified = false;
                this.gotoNew();
              })
            )
            .subscribe();
        },
        error: () => {
          this.srv.loading = this.saving = false;
        }
      });
    } else {
      this.srv.update(body).subscribe({
        next: res => {
          this.listSrv.updateRow(res);
          this.srv.loading = this.saving = false;
          this.srv.modified = false;
          this.gotoNew();
        },
        error: () => {
          this.srv.loading = this.saving = false;
        }
      });
    }
  }

  clone() {
    const data = this.srv.clone();
    this.listSrv.cloneData = data;
    if (data) {
      this.srv.observeChanges = false;
      this.srv.setData(data);
      this.toggleMode('edit');
      const curUrl = this.reuseTabSrv.curUrl;
      this.router.navigate(['../0'], { relativeTo: this.route }).then(() => {
        this.reuseTabSrv.close(curUrl);
      });
    }
  }

  cancel() {
    const modified = this.srv.modified; // !compareValue(this.dataSrv.form?.value, this.dataSrv.data);
    if (modified) {
      const modelRef = this.modal.confirm({
        nzTitle: 'Discard Changes?',
        nzContent: 'Changes you made may not be saved.',
        nzOnOk: () => {
          modelRef.close();
          this.srv.modified = false;
          if (this.id === '0') {
            this.close();
          } else {
            this.resetChanges();
          }
        },
        nzOkText: 'Discard Changes',
        nzCancelText: 'Return'
      });
    } else {
      if (this.id === '0') {
        this.close();
      } else {
        this.resetChanges();
      }
    }
  }

  private resetChanges() {
    this.srv.observeChanges = false;
    if (this.srv.form) {
      this.srv.initForm(this.srv._data);
      this.srv.form.patchValue(this.srv._data);
      this.srv.resetDataToOriginal();
      this.fs.disable(this.srv.form);
      this.srv.editing = false;
      this.srv.modified = false;
    }
  }

  reload() {
    this.srv.loading = true;
    this.srv.get(this.id).subscribe({
      next: res => {
        this.srv.setData(res);
        this.updateTitle();
        this.toggleMode(this.srv.forceEdit ? 'edit' : 'view');
      },
      error: () => {
        this.srv.loading = false;
      }
    });
  }

  handleDelete() {
    this.modal.confirm({
      nzTitle: 'Confirmation',
      nzContent: 'Are you sure you want to delete this record?',
      nzClassName: 'modal-btn',
      nzOnOk: () => {
        this.delete();
      },
      nzOkDanger: true,
      nzOkText: 'Confirm Delete'
    });
  }
  delete() {
    this.srv.deleting = true;
    this.srv.loading = true;
    this.srv
      .delete(this.srv._data.id)
      .then(() => {
        this.listSrv.removeRow(this.srv._data);
        this.srv.deleting = false;
        this.srv.loading = false;
        this.srv.modified = false;
        this.close();
      })
      .catch(() => {
        this.srv.deleting = false;
        this.srv.loading = false;
      });
  }

  close() {
    const currUrl = this.router.url.split('?')[0];
    this.router.navigate(['../../'], { relativeTo: this.route }).then(() => {
      this.reuseTabSrv.close(currUrl);
      // Notify layout to clear saved query for this tab path
      window.dispatchEvent(
        new CustomEvent('qpa-clear', { detail: { path: currUrl } })
      );
    });
  }

  prev() {
    this.loading = true;
    this.srv
      .previousRecord()
      .then((res: any) => {
        const curUrl = this.reuseTabSrv.curUrl;
        if (res) {
          this.router
            .navigate([`../${res.id}`], { relativeTo: this.route })
            .then(() => {
              this.reuseTabSrv.close(curUrl);
            });
        } else {
          this.msg.info('This is the first record');
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  next() {
    this.loading = true;
    this.srv
      .nextRecord()
      .then((res: any) => {
        const curUrl = this.reuseTabSrv.curUrl;
        if (res) {
          this.router
            .navigate([`../${res.id}`], { relativeTo: this.route })
            .then(() => {
              this.reuseTabSrv.close(curUrl);
            });
        } else {
          this.msg.info('This is the last record');
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  private updateTitle() {
    let title = `${this.srv.tabPrefix} - New`;
    if (this.srv.code) {
      title = this.srv.code;
    }
    const cachedTab = this.reuseTabSrv.get(
      this.reuseTabSrv.getUrl(this.route.snapshot)
    );
    if (cachedTab) {
      cachedTab.title.text = title;
    }
    this.reuseTabSrv.title = title;
  }
}
